/* eslint-disable eqeqeq */
import { useTranslate } from '@pankod/refine-core'

import {
  Button,
  Checkbox,
  CreateButton,
  DateField,
  FilterDropdown,
  FilterDropdownProps,
  Icons,
  Input,
  List,
  Radio,
  Select,
  ShowButton,
  Space,
  Table,
  Tag,
  Typography,
  useDrawerForm,
  useModal
} from '@pankod/refine-antd'

import { AdviceModal } from 'components/AdviceModal/AdviceModal'
import { EditableDateField } from 'components/EditableDateField/EditableDateField'
import { EditableRowField } from 'components/EditableRowField/EditableRowField'
import { EditableSelectField } from 'components/EditableSelectField.tsx/EditableSelectField'
import { EditableSubscriptionStatus } from 'components/EditableSubscriptionStatus/EditableSubscriptionStatus'
import { ExportToExcelButton } from 'components/ExportToExcelButton/ExportToExcelButton'
import { DateFilterDropdown, QuantityFilterDropdown, SelectFilterDropdown } from 'components/filterDropdown'
import { Order } from 'interfaces'
import { CreateOrder } from 'pages/orders/create'
import { Key, useEffect, useState } from 'react'
import { capitalizeFirstLetter, currency, extractMainDomainFromURL, filter, getColorLabel, getColorLabelEstimatedCost, getExecDate, getOrderExport, getOrders, getOrdersWithProcessedStatusBeforeDate, itemsCompletedCounter, MapEstimatedCostsStatusIDToText, sorter, supabaseClient } from 'utility'
import { currentUserEmail } from 'utility/authLocal'
import { ACEPTED_STATUS_ID, ADD_SUP_IVA_STATUS, ADMITTED_STATUS, ADMITTED_STATUS_TEXT, ADVERTISEMENT_STATUS_ID, ADVISE_INTRA_STATUS, ADVISE_INTRA_STATUS_PARTIAL, ADVISE_IVA_STATUS, ADVISE_IVA_STATUS_PARTIAL, CANCELLED_STATUS_ID, CHANGE_TO_REDUCED, CONTACTED_SUPPLIER_IVA_STATUS, CUSTOM_ORDER_MARKETPLACE_ID, DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT, MIN_SIZE_CHANGER, ORDER_STATUS_ID_PENDING_PAYMENT, ORDER_STATUS_ID_REQUESTED, ORDER_STATUS_ID_SUBSCRIPTION, PENDING_PAYMENT_STATUS_TEXT, PREPARED_STATUS, PROCESS_IVA_STATUS, PROCESS_STATUS_OPTIONS, PROCESSED_STATUS, SENT_BUDGE_STATUS_ID, SEQURA_PAYMENT_METHOD_ID, SHIPPED_STATUS, SHIPPING_METHOD_ECONOMY_ID, SHIPPING_METHOD_EXPRESS_ID, SUPPLEMENT_STATUS } from 'utility/constants'
import '../../custom.css'
import { OrderLiveListProps } from './list'

type CheckboxWithAdviseProps = {
  record: any
}

export const CheckboxWithAdvise: React.FC<CheckboxWithAdviseProps> = ({ record }) => {
  const t = useTranslate()
  const { modalProps, show, close } = useModal()

  const [recordCompleted, setRecordCompleted] = useState(record.completed)

  const handleCompletedChange = async (value: any, record: any) => {
    if (record.id) {
      await supabaseClient.from('orders')
        .update({
          completed: value,
          updated_by: supabaseClient.auth.user()?.email
        })
        .eq('id', record.id)

      setRecordCompleted(value)
    }
  }
  return (
    <>
      <Checkbox checked={recordCompleted} onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        show()
      }} onChange={() => null} />
      <AdviceModal
        infoText={(!recordCompleted) ? t('order.actions.adviseToMarkAsCompleted', { order_id: record.id }) : t('order.actions.adviseToMarkAsIncompleted', { order_id: record.id })}
        okFunction={() => handleCompletedChange(!recordCompleted, record)}
        close={close}
        show={show}
        modalProps={modalProps} />
    </>
  )
}
export type tablePropsProps = {
  dataSource: any[]
}

type AffectedItemsCellProps = {
  record: Order
  value: string | null | undefined
  onSave: (value: string | null, record: Order) => Promise<void>
}

const AffectedItemsCell: React.FC<AffectedItemsCellProps> = ({ record, value, onSave }) => {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState(value || '')

  const save = async () => {
    await onSave(draft.trim() || null, record)
    setEditing(false)
  }

  if (editing) {
    return <Space direction='vertical' style={{ width: '100%' }}>
      <Input.TextArea autoSize={{ minRows: 2, maxRows: 6 }} value={draft} onChange={(event) => setDraft(event.target.value)} />
      <Space>
        <Button size='small' icon={<Icons.SaveOutlined />} onClick={save}>Guardar</Button>
        <Button size='small' onClick={() => { setDraft(value || ''); setEditing(false) }}>Cancelar</Button>
      </Space>
    </Space>
  }

  return <Space align='start'>
    <Typography.Text style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{value || '—'}</Typography.Text>
    <Button size='small' shape='circle' style={{ border: 'none' }} icon={<Icons.EditOutlined />} onClick={() => setEditing(true)} />
  </Space>
}

export const OrdersLiveList: React.FC<OrderLiveListProps> = ({ select, dataToExport, getConditionalClassName, onlyPaidOrders, statusOrder, specialFilter, warehouseView = false }) => {
  let callingServer = false
  const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  const prepareInitialFilter = () => {
    let filt = [{ field: 'supplements.deleted', operator: 'eq', value: false }]

    if (statusOrder === null) {
      filt.push({ field: 'status_id', operator: 'in', value: [ORDER_STATUS_ID_REQUESTED, PROCESSED_STATUS, SUPPLEMENT_STATUS, ADMITTED_STATUS, PREPARED_STATUS, SHIPPED_STATUS] } as filter)
    } else {
      if (statusOrder !== -1) {
        filt.push({ field: 'status_id', operator: Array.isArray(statusOrder) ? 'in' : 'eq', value: statusOrder } as filter)
      }
    }

    if (specialFilter === 'cancel') {
      filt.push({ field: 'cancelation_date', operator: 'not', value: null } as filter)
    } else if (specialFilter === 'return') {
      filt.push({ field: 'return_date', operator: 'not', value: null } as filter)
    } else if (specialFilter === 'sup_pending_pay') {
      filt.push({ field: 'supplements.volumetric', operator: 'filter', secondOp: 'is', value: false } as filter)
      filt.push({ field: 'supplements.status_id', operator: 'filter', secondOp: 'neq', value: ADMITTED_STATUS } as filter)
      filt.push({ field: 'estimated_costs_status', operator: 'is', value: null } as filter)
    } else if (specialFilter === 'sup_pending_pay_no_volumetric') {
      filt.push({ field: 'supplements.volumetric', operator: 'filter', secondOp: 'is', value: false } as filter)
      filt.push({ field: 'supplements.status_id', operator: 'filter', secondOp: 'eq', value: ORDER_STATUS_ID_PENDING_PAYMENT } as filter)
    } else if (specialFilter === 'sup_pending_pay_volumetric') {
      filt.push({ field: 'supplements.volumetric', operator: 'filter', secondOp: 'is', value: true } as filter)
      filt.push({ field: 'supplements.status_id', operator: 'filter', secondOp: 'eq', value: ORDER_STATUS_ID_PENDING_PAYMENT } as filter)
    } else if (specialFilter === 'despared') {
      filt.push({ field: 'location', operator: 'not', value: null } as filter)
    } else if (specialFilter === 'refunds' || specialFilter === 'refunds_provider') {
      filt = [...filt.filter((x: filter) => x.field !== 'supplements.deleted')]
      filt.push({ field: 'status_id', operator: 'gte', value: PROCESSED_STATUS } as filter)
    } else if (specialFilter === 'free_vol') {
      filt.push({ field: 'purchase_conditions->>free_vol', operator: 'eq', value: 'true' } as filter)
      filt.push({ field: 'shipping_method_id', operator: 'eq', value: SHIPPING_METHOD_ECONOMY_ID } as filter)
    } else if (specialFilter === 'budgeted') {
      filt.push({ field: 'estimated_costs_status', operator: 'in', value: [ADVERTISEMENT_STATUS_ID, SENT_BUDGE_STATUS_ID, ACEPTED_STATUS_ID] } as filter)
      filt.push({ field: 'cancelation_date', operator: 'is', value: null } as filter)
      filt.push({ field: 'status_id', operator: 'in', value: [ORDER_STATUS_ID_REQUESTED, SUPPLEMENT_STATUS] } as filter)
    } else if (specialFilter === 'requested') {
      filt.push({ field: 'estimated_costs_status', operator: 'is', value: null } as filter)
      filt.push({ field: 'iva_status', operator: 'is', value: null } as filter)
    } else if (specialFilter === 'estimated') {
      filt.push({ field: 'estimated_delivered_date', operator: 'not', value: null } as filter)
      filt.push({ field: 'estimated_delivered_date', operator: 'lte', value: new Date(Date.now()).toISOString() } as filter)
      filt.push({ field: 'location', operator: 'is', value: null } as filter)
    } else if (specialFilter === 'processed') {
      filt.push({ field: 'estimated_delivered_date', operator: 'is', value: null } as filter)
      filt.push({ field: 'status_id', operator: 'eq', value: PROCESSED_STATUS } as filter)
      filt.push({ field: 'location', operator: 'is', value: null } as filter)
    } else if (specialFilter === 'sequra') {
      filt.push({ field: 'payment_method_id', operator: 'eq', value: SEQURA_PAYMENT_METHOD_ID } as filter)
    } else if (specialFilter === 'iva_check') {
      filt.push({ field: 'iva_status', operator: 'not', value: null } as filter)
    } else if (specialFilter === 'corrections') {
      filt.push({ field: 'edited', operator: 'eq', value: true } as filter)
      filt.push({ field: 'invoices.reviewed', operator: 'eq', value: true } as filter)
    }

    return filt
  }

  const [tableProps, setTableProps] = useState<tablePropsProps>({ dataSource: [] })
  const [filters, setFilters] = useState<filter[]>(prepareInitialFilter())
  const [sorter, setSorter] = useState<sorter>({ field: 'id', ascending: false })

  const getOrdersList = async (resetPages: boolean = false) => {
    if (!callingServer) {
      setLoading(true)
      let cPage = (resetPages) ? 1 : currentPage
      let cPageSize = pageSize
      callingServer = true
      let specialFilt = null
      // Special case, we need force to query more element and filter manually
      if (specialFilter === 'sup_pending_pay') {
        select = select.replace('supplements(', 'sup_count:supplements(count), supplements:supplements(deleted,')
        cPage = 1
        cPageSize = 10000
      } else if (specialFilter === 'sup_pending_pay_volumetric') {
        select = select.replace('supplements(', 'supplements!inner(')
      } else if (specialFilter === 'sup_pending_pay_no_volumetric') {
        select = select.replace('supplements(', 'supplements!inner(')
      } else if (specialFilter === 'refunds' || specialFilter === 'refunds_provider') {
        cPage = 1
        cPageSize = 10000
        select = select.replace(', supplements(supplement, volumetric, description, status(id, name))', ', refunds!inner(type, status_id, deleted, amount, parent_supplement_id))')
        specialFilt = [...filters]
        specialFilt.push({ field: 'refunds.type', operator: 'eq', value: (specialFilter === 'refunds_provider') ? 'supplier' : 'client' } as filter)
        specialFilt.push({ field: 'refunds.deleted', operator: 'eq', value: false } as filter)
        specialFilt.push({ field: 'refunds.status_id', operator: 'eq', value: ORDER_STATUS_ID_PENDING_PAYMENT } as filter)
      } else if (specialFilter === 'budgeted') {
        cPage = 1
        cPageSize = 10000
      } else if (specialFilter === 'sequra') {
        cPage = 1
        cPageSize = 10000
        select = select.replace(', sequra_disbursement_ref', ', sequra_disbursement_ref,  refunds(type, status_id, deleted, amount)')
      } else if (specialFilter === 'corrections') {
        cPage = 1
        cPageSize = 10000
      } else if (specialFilter === 'despared') {
        select = select.replace(', sequra_disbursement_ref', ', sequra_disbursement_ref,  items!inner(id, delivered_warehouse, disabled)')
      } else if (specialFilter === 'iva_check') {
        select = select.replace(', sequra_disbursement_ref', ', sequra_disbursement_ref,  items!inner(id, url, seller), shipping_method_id')
        specialFilt = [...filters]
        specialFilt.push({ field: 'estimated_costs_status', operator: 'is', value: null } as filter)
      } else if (specialFilter === 'subscriptions') {
        select = select.replace(', sequra_disbursement_ref', ', sequra_disbursement_ref, subscribed_order(id, name), user_id(id, email), user_subscription_id(id, status, renew_at, expired_at, user_id)')
      } else if (specialFilter === 'processed') {
        // get from audit orders the orders taht processed status is not changed in the last 7 days
        const { data: ordersWithProcessedStatusBeforeDate } = await getOrdersWithProcessedStatusBeforeDate(sevenDaysAgo)

        // remove duplicated resource_id from ordersWithProcessedStatusBeforeDate
        const cleanedData = ordersWithProcessedStatusBeforeDate?.reduce((acc: any[], item: any) => {
          if (!acc.find((x: any) => x.resource_id === item.resource_id)) {
            acc.push(item)
          }
          return acc
        }, [])

        const orderIds = cleanedData?.map((x: any) => x.resource_id) || []
        specialFilt = [...filters]
        specialFilt.push({ field: 'id', operator: 'in', value: orderIds } as filter)
      }

      // console.log(specialFilt, filters)

      let { data: dataSource, count } = await getOrders(select, cPage, cPageSize, [...prepareInitialFilter(), ...specialFilt || filters], sorter)

      // Special cases
      if (specialFilter === 'sup_pending_pay') {
        console.log(dataSource.map((x: any) => x.sup_count[0].count))
        dataSource = dataSource.filter((x: any) => x.sup_count[0].count === 0)
        console.log(dataSource.map((x: any) => x.sup_count[0].count))
        count = dataSource.length
      } else if (specialFilter === 'sup_pending_pay_no_volumetric') {
        dataSource = dataSource.filter((x: any) => x.estimated_costs_status === null || x.estimated_costs_status === ACEPTED_STATUS_ID)
      } else if (specialFilter === 'budgeted') {
        dataSource = dataSource.filter((x: any) => {
          const haveVolSuplement = x.supplements.find((s: any) => s.volumetric && s.description === null)
          return !haveVolSuplement
        }).filter((x: any) => {
          const havePendingPaySupplement = x.supplements.find((s: any) => !s.volumetric && s.description !== null && s.status.id === ORDER_STATUS_ID_PENDING_PAYMENT)
          // console.log(x.id, x.estimated_costs_status, x.supplements, havePendingPaySupplement)
          if (havePendingPaySupplement) return x.estimated_costs_status !== ACEPTED_STATUS_ID
          else return ([ADVERTISEMENT_STATUS_ID, SENT_BUDGE_STATUS_ID, ACEPTED_STATUS_ID].includes(x.estimated_costs_status))
        })
        count = dataSource.length
      } else if (specialFilter === 'refunds_provider' || specialFilter === 'refunds') {
        const filterRefund = filters.find((x: { field: string }) => x.field === '')
        const computeRefundAmount = (order: any) => (order.refunds?.filter((r: any) => {
          const isPendingRefund = !r.deleted && r.status_id === 0 && r.type === ((specialFilter === 'refunds_provider') ? 'supplier' : 'client')
          return isPendingRefund && (specialFilter === 'refunds' ? r.parent_supplement_id == null : true)
        }) || []).map((r: any) => r.amount || 0).reduce((a: number, b: number) => a + b, 0)

        dataSource = dataSource.filter((x: any) => {
          const totalRefundAmount = computeRefundAmount(x)
          if (filterRefund) {
            if (filterRefund.operator === 'eq') {
              return (totalRefundAmount === Number(filterRefund.value))
            } else if (filterRefund.operator === 'gt') {
              return (totalRefundAmount > Number(filterRefund.value))
            } else if (filterRefund.operator === 'lt') {
              return (totalRefundAmount < Number(filterRefund.value))
            }
            return true
          }
          return totalRefundAmount > 0
        })
        count = dataSource.length
      } else if (specialFilter === 'corrections') {
        dataSource = dataSource.filter((x: any) => x.edited === true && x.invoices?.reviewed === true)
        count = dataSource.length
      }

      const tableProps = {
        dataSource: dataSource
      }
      tableProps.dataSource = (tableProps.dataSource as any)?.map((row: any) => {
        row.action_dates = { cancelation_date: row.cancelation_date, return_date: row.return_date }
        return row
      })

      if (specialFilter === 'subscriptions' && filterUserEmail) {
        const emailToFilter = Array.isArray(filterUserEmail) ? filterUserEmail[0] : filterUserEmail
        tableProps.dataSource = tableProps.dataSource.filter((row: any) => row.user_id?.email === emailToFilter)
      }

      if (onlyPaidOrders) {
        tableProps.dataSource = tableProps.dataSource?.filter((x: any) => x.status_id && x.status_id > 0)
      }

      setTableProps(tableProps)
      setTotalData(count || 0)
      setLoading(false)
    }
    callingServer = false
  }

  const [totalData, setTotalData] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(localStorage.getItem('ordersPage') ? parseInt(localStorage.getItem('ordersPage') || '1') : 1)
  const [pageSize, setPageSize] = useState(localStorage.getItem('ordersPageSize') ? parseInt(localStorage.getItem('ordersPageSize') || '10') : 10)
  const [loading, setLoading] = useState(false)
  const [additionalFilter, setAdditionalFilter] = useState<boolean>(false)

  // filter values
  const [filterId, setFilterId] = useState<number|undefined>(undefined)
  const [filteredIdState, setFilteredIdState] = useState<boolean>(false)
  const [filterAlias, setFilterAlias] = useState<string|undefined>(undefined)
  const [filteredAliasState, setFilteredAliasState] = useState<boolean>(false)
  const [filterLocation, setFilterLocation] = useState<string|undefined>(undefined)
  const [filteredLocationState, setFilteredLocationState] = useState<boolean>(false)
  const [filterMarketplaceId, setFilterMarketplaceId] = useState<Key[]|undefined>(undefined)
  const [filteredMarketplaceIdState, setFilteredMarketplaceIdState] = useState<boolean>(false)
  const [filterStatusId, setFilterStatusId] = useState<Key[]|undefined>(undefined)
  const [filterEstimatedStatusId, setFilterEstimatedStatusId] = useState<Key[]|undefined>(undefined)
  const [filterIvaStatusId, setFilterIvaStatusId] = useState<Key[]|undefined>(undefined)
  const [filteredStatusIdState, setFilteredStatusIdState] = useState<boolean>(false)
  const [filteredEstimatedStatusIdState, setFilteredEstimatedStatusIdState] = useState<boolean>(false)
  const [filteredIvaStatusIdState, setFilteredIvaStatusIdState] = useState<boolean>(false)
  const [filterCompleted, setFilterCompleted] = useState<boolean|undefined>(undefined)
  const [filterPriority, setFilterPriority] = useState<boolean|undefined>(undefined)
  const [filterDisbursement, setFilterDisbursement] = useState<string|undefined>(undefined)
  const [filterSubscriptionType, setFilterSubscriptionType] = useState<Key[]|undefined>(undefined)
  const [filterProcessStatus, setFilterProcessStatus] = useState<string|undefined>(undefined)
  const [filterUserEmail, setFilterUserEmail] = useState<Key[]|undefined>(undefined)

  const [filteredDisbursementState, setFilteredDisbursementState] = useState<boolean>(false)
  const [filteredCreatedAtState, setFilteredCreatedAtState] = useState<boolean>(false)
  const [filteredTotalState, setFilteredTotalState] = useState<boolean>(false)
  const [filteredCancelDateState, setFilteredCancelDateState] = useState<boolean>(false)
  const [filteredCompletedState, setFilteredCompletedState] = useState<boolean>(false)
  const [filteredPriorityState, setFilteredPriorityState] = useState<boolean>(false)
  const [filteredEstimatedDateState, setFilteredEstimatedDateState] = useState<boolean>(false)
  const [filteredSubscriptionTypeState, setFilteredSubscriptionTypeState] = useState<boolean>(false)
  const [filteredProcessStatusState, setFilteredProcessStatusState] = useState<boolean>(false)
  const [filteredUserEmailState, setFilteredUserEmailState] = useState<boolean>(false)

  const t = useTranslate()

  useEffect(() => {
    if (specialFilter === 'processed') {
      setSorter({ field: 'processed_at', ascending: false })
    } else {
      setSorter({ field: 'id', ascending: false })
    }
  }, [specialFilter])

  useEffect(() => {
    // console.log('filters -->', filters, additionalFilter)
    if (!callingServer) {
      getOrdersList(additionalFilter)
    }
  }, [filters, sorter.ascending, sorter.field])

  useEffect(() => {
    // console.log('sorter -->', sorter)
    if (!callingServer) {
      if (tableProps.dataSource.length > 0) {
        getOrdersList()
      }
    }
  }, [sorter, currentPage, pageSize])

  const { Text } = Typography

  const excludedFields = (onlyPaidOrders) ? [PENDING_PAYMENT_STATUS_TEXT] : ['']

  const {
    drawerProps: createDrawerProps,
    formProps: createFormProps,
    saveButtonProps: createSaveButtonProps,
    show: createShow,
    close: createClose
  } = useDrawerForm<Order>({
    action: 'create',
    resource: 'orders',
    redirect: false
  })

  let controlWidth = window.innerWidth
  const fixedMobile = controlWidth > 700 ? 'left' : false
  // previous controlWidth
  // controlWidth = controlWidth < 728 ? 750 : 200
  controlWidth = controlWidth < 728 ? 400 : 105

  const optionsGetter = (record?: any): { label: string, value: string }[] => {
    let options = [
      { label: t('iva_status.select.advise_iva'), value: ADVISE_IVA_STATUS },
      { label: t('iva_status.select.advise_iva_partial'), value: ADVISE_IVA_STATUS_PARTIAL },
      { label: t('iva_status.select.advise_intra'), value: ADVISE_INTRA_STATUS },
      { label: t('iva_status.select.advise_intra_partial'), value: ADVISE_INTRA_STATUS_PARTIAL },
      { label: t('iva_status.select.contacted_supplier'), value: CONTACTED_SUPPLIER_IVA_STATUS },
      { label: t('iva_status.select.process'), value: PROCESS_IVA_STATUS },
      { label: t('iva_status.select.add_iva_supplement'), value: ADD_SUP_IVA_STATUS },
      { label: t('iva_status.select.change_to_reduced'), value: CHANGE_TO_REDUCED }
    ]

    if (record?.shipping_method_id === SHIPPING_METHOD_EXPRESS_ID) {
      options = options.filter((option:any) => [CONTACTED_SUPPLIER_IVA_STATUS, PROCESS_IVA_STATUS, ADD_SUP_IVA_STATUS].includes(option.value))
      return options
    }

    if (record && record.items) {
      const itemsWithSeller = record.items.filter((i: { id: number, seller: string }) => !!i.seller && i.seller.toLowerCase() !== 'seller error')
      // If is a order without sellers or just with one seller, show change to reduced
      if (itemsWithSeller.length <= 1) {
        options = options.filter((o) => ![ADVISE_IVA_STATUS_PARTIAL, ADVISE_INTRA_STATUS_PARTIAL, ADD_SUP_IVA_STATUS].includes(o.value))
        // else if if is an order with more than one seller
      } else if (itemsWithSeller.length > 1) {
        options = options.filter((o) => ![ADVISE_IVA_STATUS, ADVISE_INTRA_STATUS, CHANGE_TO_REDUCED].includes(o.value))
      }
    }
    return options
  }

  const handleOrderFieldChange = async (field: string, value: any, record: any, func: Function) => {
    if (record.id) {
      await supabaseClient
        .from('orders')
        .update({
          [field]: value,
          updated_by: supabaseClient.auth.user()?.email
        })
        .eq('id', record.id)
      const val = tableProps?.dataSource?.find(x => x.id === record.id)
      if (val) {
        val[field] = value
      }
      func(true)
    }
  }

  const handleIvaStatusChange = async (value: any, record: any, func: Function) => {
    if (record.id) {
      await supabaseClient
        .from('orders')
        .update({
          iva_status: value,
          updated_by: supabaseClient.auth.user()?.email
        })
        .eq('id', record.id)
      const val = tableProps?.dataSource?.find(x => x.id === record.id)
      if (val) {
        val.iva_status = value
      }

      if (value === CONTACTED_SUPPLIER_IVA_STATUS) {
        await supabaseClient
          .from('queue_registry')
          .insert({
            created_at: new Date(Date.now()).toISOString(),
            type: 'pending',
            identifier: `contact_supplier_${record.id}`,
            exec_at: getExecDate(new Date(Date.now()), 72)
          })
      }

      func(true)
    }
  }

  const handleReviewedAtChange = async (value: any, record: any) => {
    if (record.id) {
      await supabaseClient
        .from('orders')
        .update({
          reviewed_at: value,
          updated_by: supabaseClient.auth.user()?.email
        })
        .eq('id', record.id)
      const val = tableProps?.dataSource?.find(x => x.id === record.id)
      if (val) {
        val.reviewed_at = value
      }
      setTableProps({ ...tableProps })
    }
  }

  const CreatedAtColumn = (
    <Table.Column
      key='created_at'
      dataIndex="created_at"
      align="center"
      title={t('order.fields.createdAt')}
      render={(value) => <DateField format={DEFAULT_DATE_TIME_FORMAT} value={value}/>}
      sorter
      width= {fixedMobile ? 10 : 1}
      filtered={filteredCreatedAtState}
      filterDropdown={() => (
        <DateFilterDropdown
          field='created_at'
          filters={filters}
          setFilters={(newFilter: any, method: string) => {
            if (newFilter.length > 0 && method === 'merge') {
              let filtersToAdd = [...filters]

              if (filters.find((x: filter) => x.field === 'created_at' && x.operator === 'gte')) {
                const updatedFilters = [...filtersToAdd]
                const index = updatedFilters.findIndex((x: filter) => x.field === 'created_at' && x.operator === 'gte')
                updatedFilters[index].value = newFilter[0].value

                filtersToAdd = [...updatedFilters]
              } else {
                filtersToAdd = [...filtersToAdd, ...[newFilter[0]]]
              }

              if (filters.find((x: filter) => x.field === 'created_at' && x.operator === 'lte')) {
                const updatedFilters = [...filtersToAdd]
                const index = updatedFilters.findIndex((x: filter) => x.field === 'created_at' && x.operator === 'lte')
                updatedFilters[index].value = newFilter[1].value

                filtersToAdd = [...updatedFilters]
              } else {
                filtersToAdd = [...filtersToAdd, ...[newFilter[1]]]
              }

              setFilters([...filtersToAdd])
              setFilteredCreatedAtState(true)
              setAdditionalFilter(true)
            } else {
              setFilters([...filters.filter((x: filter) => x.field !== 'created_at')])
              setFilteredCreatedAtState(false)
              setAdditionalFilter(false)
            }
          }}
        />
      )}
    />
  )

  const processStatusOptions = PROCESS_STATUS_OPTIONS.map(status => ({ label: status, value: status }))

  const handleProcessStatusChange = async (value: string, record: any) => {
    if (record.id) {
      await supabaseClient
        .from('orders')
        .update({
          process_status: value,
          updated_by: supabaseClient.auth.user()?.email
        })
        .eq('id', record.id)
      const val = tableProps?.dataSource?.find(x => x.id === record.id)
      if (val) {
        val.process_status = value
      }
      setTableProps({ ...tableProps })
    }
  }

  async function exportOrders () {
    let selection = select
    let specialFilt = null

    if (specialFilter === 'sup_pending_pay') {
      selection = selection.replace('supplements(', 'sup_count:supplements(count), supplements:supplements(deleted,')
    } else if (specialFilter === 'sup_pending_pay_volumetric') {
      selection = selection.replace('supplements(', 'supplements!inner(')
    } else if (specialFilter === 'sup_pending_pay_no_volumetric') {
      selection = selection.replace('supplements(', 'supplements!inner(')
    } else if (specialFilter === 'refunds' || specialFilter === 'refunds_provider') {
      selection = selection.replace(', supplements(supplement, volumetric, description, status(id, name))', ', refunds!inner(type, status_id, deleted, amount, parent_supplement_id))')
      specialFilt = [...filters]
      specialFilt.push({ field: 'refunds.type', operator: 'eq', value: (specialFilter === 'refunds_provider') ? 'supplier' : 'client' } as filter)
      specialFilt.push({ field: 'refunds.deleted', operator: 'eq', value: false } as filter)
      specialFilt.push({ field: 'refunds.status_id', operator: 'eq', value: ORDER_STATUS_ID_PENDING_PAYMENT } as filter)
    } else if (specialFilter === 'sequra') {
      selection = selection.replace(', sequra_disbursement_ref', ', sequra_disbursement_ref,  refunds(type, status_id, deleted, amount)')
    } else if (specialFilter === 'despared') {
      selection = selection.replace(', sequra_disbursement_ref', ', sequra_disbursement_ref,  items(id, delivered_warehouse, disabled)')
    } else if (specialFilter === 'subscriptions') {
      selection = selection.replace(', sequra_disbursement_ref', ', sequra_disbursement_ref,  subscribed_order(id, name), user_id(id, email), user_subscription_id(id, status)')
    } else if (specialFilter === 'processed') {
      // get from audit orders the orders taht processed status is not changed in the last 7 days
      const { data: ordersWithProcessedStatusBeforeDate } = await getOrdersWithProcessedStatusBeforeDate(sevenDaysAgo)

      // remove duplicated resource_id from ordersWithProcessedStatusBeforeDate
      const cleanedData = ordersWithProcessedStatusBeforeDate?.reduce((acc: any[], item: any) => {
        if (!acc.find((x: any) => x.resource_id === item.resource_id)) {
          acc.push(item)
        }
        return acc
      }, [])

      const orderIds = cleanedData?.map((x: any) => x.resource_id) || []
      specialFilt = [...filters]
      specialFilt.push({ field: 'id', operator: 'in', value: orderIds } as filter)
    }

    let data = await getOrderExport(selection, specialFilt || filters, sorter)

    if (onlyPaidOrders) {
      data = data?.filter((x: any) => x.status_id && x.status_id > 0)
    }

    return dataToExport(data as any[])
  }

  return (
    <>
      <List
        resource='orders'
        title={
          <>
            {t('order.orders')}
            <Text type='secondary' style={{ fontSize: 10, display: 'block', lineHeight: 2 }}>{t('order.cancelHelper')}</Text>
            <Text type='secondary' style={{ fontSize: 10, display: 'block', lineHeight: 2 }}>{t('order.returnHelper')}</Text>
          </>
        }
        headerProps={{
          extra: !warehouseView && <>
            <CreateButton onClick={() => createShow()}>{t('order.actions.addOrder')}</CreateButton>
            <ExportToExcelButton filename='Pedidos' asyncFunction={() => exportOrders()} />
          </>
        }}
      >
        <Table
          {...tableProps}
          rowKey="id"
          rowClassName={(record) => getConditionalClassName(record)}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalData,
            showSizeChanger: !!(tableProps.dataSource.length > MIN_SIZE_CHANGER),
            onChange (page, pageSize) {
              setCurrentPage(page)
              setPageSize(pageSize)
              localStorage.setItem('ordersPage', page.toString() || '')
              localStorage.setItem('ordersPageSize', pageSize.toString() || '')
            }
          }}
          onChange={(_pagination: any, _filters: any, sorter: any, _extra: any) => {
            if (sorter && sorter.order) {
              setSorter({ field: sorter.field, ascending: (sorter.order === 'ascend') })
            } else {
              setSorter({ field: 'id', ascending: false })
            }
          }}
          scroll={{ x: `${controlWidth}%`, y: '60vh' }}
          >
          <Table.Column
            key='id'
            fixed = {fixedMobile ? 'left' : false}
            dataIndex="id"
            align="center"
            title={t('order.fields.id')}
            filtered={filteredIdState}
            filterDropdown={(props) => (
              <FilterDropdown {...props}
                mapValue={(selectedKeys) => {
                  setFilterId(Number(selectedKeys))
                  return selectedKeys
                }}
                clearFilters={() => {
                  setFilters([...filters.filter((x: filter) => x.field !== 'id')])
                  setFilterId(undefined)
                  setFilteredIdState(false)
                  setAdditionalFilter(false)
                }}
                confirm={() => {
                  if (filterId) {
                    if (filters.find((x: filter) => x.field === 'id')) {
                      const updatedFilters = [...filters]
                      const index = updatedFilters.findIndex((x: filter) => x.field === 'id')
                      updatedFilters[index].value = filterId

                      setFilters([...updatedFilters])
                    } else {
                      setFilters([...filters, ...[{ field: 'id', operator: 'eq', value: filterId }]])
                    }
                    setFilteredIdState(true)
                    setAdditionalFilter(true)
                  }
                }}
              >
                <Input type='text' />
              </FilterDropdown>
            )}
            sorter
            width= {fixedMobile ? 7 : 1}
          />
          {(specialFilter !== 'subscriptions' && specialFilter !== 'processed') && (
            <Table.Column
              key='alias'
              fixed = {fixedMobile ? 'left' : false}
              dataIndex="alias"
              align="center"
              title={t('order.fields.alias')}
              sorter
              width= {fixedMobile ? 7 : 1}
              filtered={filteredAliasState}
              filterDropdown={(props) => (
                <FilterDropdown {...props}
                  mapValue={(selectedKeys) => {
                    setFilterAlias(selectedKeys.toString().toUpperCase())
                    return selectedKeys.toString().toUpperCase()
                  }}
                  clearFilters={() => {
                    setFilters([...filters.filter((x: filter) => x.field !== 'alias')])
                    setFilterId(undefined)
                    setFilteredAliasState(false)
                    setAdditionalFilter(false)
                  }}
                  confirm={() => {
                    if (filterAlias) {
                      if (filters.find((x: filter) => x.field === 'alias')) {
                        const updatedFilters = [...filters]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'alias')
                        updatedFilters[index].value = filterAlias

                        setFilters([...updatedFilters])
                      } else {
                        setFilters([...filters, ...[{ field: 'alias', operator: 'eq', value: filterAlias }]])
                      }
                      setFilteredAliasState(true)
                      setAdditionalFilter(true)
                    }
                  }}
                >
                  <Input type='text' />
                </FilterDropdown>
              )}
            />
          )}
          {(specialFilter === 'subscriptions') && (
            <>
              <Table.Column
                key='subscriptions_type'
                dataIndex={['subscribed_order', 'name']}
                align="center"
                title={t('order.fields.subscriptionType')}
                sorter
                width={fixedMobile ? 10 : 2}
                render={(value) => value ?? '-'}
                filtered={filteredSubscriptionTypeState}
                filterDropdown={(props: FilterDropdownProps) => {
                  props.setSelectedKeys = setFilterSubscriptionType
                  props.clearFilters = () => {
                    setFilters([...filters.filter((x: filter) => x.field !== 'subscribed_order.id')])
                    setFilterSubscriptionType(undefined)
                    setFilteredSubscriptionTypeState(false)
                    setAdditionalFilter(false)
                  }
                  props.confirm = () => {
                    if (filterSubscriptionType) {
                      if (filters.find((x: filter) => x.field === 'subscribed_order.id')) {
                        const updatedFilters = [...filters]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'subscribed_order.id')
                        updatedFilters[index].value = filterSubscriptionType
                        setFilters([...updatedFilters])
                      } else {
                        setFilters([...filters, ...[{ field: 'subscribed_order.id', operator: 'in', value: filterSubscriptionType }]])
                      }
                      setFilteredSubscriptionTypeState(true)
                      setAdditionalFilter(true)
                    }
                  }
                  return <SelectFilterDropdown
                    props={props}
                    entity='subscriptions'
                    optionLabel='name'
                    optionValue='id'
                  />
                }}
              />
              <Table.Column
                key='user_email'
                dataIndex={['user_id', 'email']}
                align="center"
                title={t('order.fields.userEmail')}
                sorter
                width={fixedMobile ? 10 : 2}
                render={(value) => value ?? '-'}
                filtered={filteredUserEmailState}
                filterDropdown={(props) => {
                  props.setSelectedKeys = setFilterUserEmail
                  props.confirm = () => {
                    const emailToFilter = Array.isArray(filterUserEmail) ? filterUserEmail[0] : filterUserEmail
                    if (emailToFilter) {
                      if (filters.find((x: filter) => x.field === 'user_id.email')) {
                        const updatedFilters = [...filters]
                        const idx = updatedFilters.findIndex((x: filter) => x.field === 'user_id.email')
                        updatedFilters[idx].value = emailToFilter
                        setFilters([...updatedFilters])
                      } else {
                        setFilters([...filters, ...[{ field: 'user_id.email', operator: 'eq', value: emailToFilter }]])
                      }
                      setFilteredUserEmailState(true)
                      setAdditionalFilter(true)
                    } else {
                      setFilters(filters.filter((x: filter) => x.field !== 'user_id.email'))
                      setFilterUserEmail(undefined)
                      setFilteredUserEmailState(false)
                      setAdditionalFilter(false)
                    }
                  }
                  props.clearFilters = () => {
                    setFilters(filters.filter((x: filter) => x.field !== 'user_id.email'))
                    setFilterUserEmail(undefined)
                    setFilteredUserEmailState(false)
                    setAdditionalFilter(false)
                  }
                  return (
                    <SelectFilterDropdown
                      props={props}
                      entity='users'
                      optionLabel='email'
                      optionValue='email'
                      type='string'
                      filters={[{
                        field: 'deleted',
                        operator: 'eq',
                        value: false
                      }]}
                    />
                  )
                }}
              />
            </>
          )}
          {(specialFilter === 'processed') && CreatedAtColumn}
          {(specialFilter === 'processed') && (
            <>
            <Table.Column
              key='processed_at'
              dataIndex='processed_at'
              align='center'
              title={t('order.fields.processed_date')}
              sorter
              defaultSortOrder={sorter.field === 'processed_at' ? (sorter.ascending ? 'ascend' : 'descend') : undefined}
              width={fixedMobile ? 10 : 2}
              render={(value: any) => value ? <DateField value={value} format={DEFAULT_DATE_TIME_FORMAT} /> : '-'}
            />
            <Table.Column
              key='notes'
              dataIndex="notes"
              align="center"
              title={t('order.fields.note')}
              width={fixedMobile ? 16 : 2}
              render={(value, record: Order) => (
                <Space style={{ justifyContent: 'center' }}>
                  <EditableRowField key={value} record={record} handleSave={(value: any, record: any, func: Function) => handleOrderFieldChange('notes', value, record, func)} notename='notes'/>
                </Space>
              )}
            />
            <Table.Column
              key='reviewed_at'
              dataIndex='reviewed_at'
              align='center'
              title={t('order.fields.reviewed_date')}
              sorter
              defaultSortOrder={sorter.field === 'reviewed_at' ? (sorter.ascending ? 'ascend' : 'descend') : undefined}
              width={fixedMobile ? 16 : 2}
              render={(_value: any, record: any) => (
                <EditableDateField
                  record={record}
                  field='reviewed_at'
                  handleSave={handleReviewedAtChange}
                />
              )} />
            </>
          )}
          {(specialFilter === 'estimated') && (
            <Table.Column
            key='estimated_notes'
            dataIndex="estimated_notes"
            align="center"
            title={t('order.fields.note')}
            width={fixedMobile ? 16 : 2}
            render={(value, record: Order) => (
              <Space style={{ justifyContent: 'center' }}>
                <EditableRowField key={value} record={record} handleSave={(value: any, record: any, func: Function) => handleOrderFieldChange('estimated_notes', value, record, func)} notename='estimated_notes'/>
              </Space>
            )}
            />
          )}
          {(specialFilter === 'processed') && (
            <Table.Column
              key='process_status'
              dataIndex='process_status'
              align='center'
              title={t('order.fields.process_status')}
              width={fixedMobile ? 10 : 2}
              render={(_value, record: any) => {
                const currentValue = record.process_status || 'Tránsito'
                return (
                  <Select
                    style={{ minWidth: 120 }}
                    value={currentValue}
                    onChange={(value: string) => handleProcessStatusChange(value, record)}
                    options={processStatusOptions}
                  />
                )
              }}
              filtered={filteredProcessStatusState}
              filterDropdown={(props: FilterDropdownProps) => (
                <FilterDropdown
                  {...props}
                  mapValue={(selectedKeys) => {
                    const selectedValue = selectedKeys?.toString() || undefined
                    setFilterProcessStatus(selectedValue)
                    return selectedValue
                  }}
                  clearFilters={() => {
                    setFilters([...filters.filter((x: filter) => x.field !== 'process_status')])
                    setFilterProcessStatus(undefined)
                    setFilteredProcessStatusState(false)
                    setAdditionalFilter(false)
                  }}
                  confirm={() => {
                    if (filterProcessStatus) {
                      if (filters.find((x: filter) => x.field === 'process_status')) {
                        const updatedFilters = [...filters]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'process_status')
                        updatedFilters[index].value = filterProcessStatus
                        setFilters([...updatedFilters])
                      } else {
                        setFilters([...filters, ...[{ field: 'process_status', operator: 'eq', value: filterProcessStatus }]])
                      }
                      setFilteredProcessStatusState(true)
                      setAdditionalFilter(true)
                    }
                  }}
                >
                  <Select
                    style={{ minWidth: 200 }}
                    value={filterProcessStatus}
                    onChange={(value: string) => setFilterProcessStatus(value)}
                    options={processStatusOptions}
                  />
                </FilterDropdown>
              )}
            />
          )}
          {(specialFilter !== 'subscriptions' && specialFilter !== 'processed') && (
            <><Table.Column
              key="is_priority"
              dataIndex="is_priority"
              align="center"
              title={t('order.fields.is_priority')}
              sorter
              width={fixedMobile ? 10 : 2}
              render={(value) => (
                <Space style={{ justifyContent: 'center' }}>
                  {(value) ? <Icons.ExclamationCircleFilled style={{ fontSize: 30, color: '#f16868' }} /> : null}
                </Space>
              )}
              filtered={filteredPriorityState}
              filterDropdown={(props: FilterDropdownProps) => (
                <FilterDropdown {...props}
                  mapValue={(selectedKeys) => {
                    setFilterPriority(selectedKeys.toString() === 'true')
                    return selectedKeys.toString() === 'true'
                  } }
                  clearFilters={() => {
                    setFilters([...filters.filter((x: filter) => x.field !== 'is_priority')])
                    setFilterPriority(undefined)
                    setFilteredPriorityState(false)
                    setAdditionalFilter(false)
                  } }
                  confirm={() => {
                    if (typeof filterPriority === 'boolean') {
                      if (filters.find((x: filter) => x.field === 'is_priority')) {
                        const updatedFilters = [...filters]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'is_priority')
                        updatedFilters[index].value = filterPriority

                        setFilters([...updatedFilters])
                      } else {
                        setFilters([...filters, ...[{ field: 'is_priority', operator: 'eq', value: filterPriority }]])
                      }
                      setFilteredPriorityState(true)
                      setAdditionalFilter(true)
                    }
                  } }
                >
                  <Radio.Group>
                    <Radio value={true}>{t('order.fields.priority')}</Radio>
                    <Radio value={false}>{t('order.fields.noPriority')}</Radio>
                  </Radio.Group>
                </FilterDropdown>
              )} /><Table.Column
                key='package_number'
                dataIndex="package_number"
                align="center"
                title={t('order.fields.package_number')}
                width={fixedMobile ? 7 : 1} /><Table.Column
                key='location'
                dataIndex="location"
                align="center"
                title={t('order.fields.location')}
                width={fixedMobile ? 12 : 2}
                render={(value, record: Order) => (
                  <Space style={{ justifyContent: 'center' }}>
                    <EditableRowField key={value} record={record} handleSave={(value: any, record: any, func: Function) => handleOrderFieldChange('location', value, record, func)} />
                  </Space>
                )}
                sorter
                filtered={filteredLocationState}
                filterDropdown={(props) => (
                  <FilterDropdown {...props}
                    mapValue={(selectedKeys) => {
                      setFilterLocation(selectedKeys.toString() || undefined)
                      return selectedKeys.toString()
                    } }
                    clearFilters={() => {
                      setFilters([...filters.filter((x: filter) => x.field !== 'location')])
                      setFilterLocation(undefined)
                      setFilteredLocationState(false)
                      setAdditionalFilter(false)
                    } }
                    confirm={() => {
                      if (filterLocation) {
                        if (filters.find((x: filter) => x.field === 'location')) {
                          const updatedFilters = [...filters]
                          const index = updatedFilters.findIndex((x: filter) => x.field === 'location')
                          updatedFilters[index].value = filterLocation

                          setFilters([...updatedFilters])
                        } else {
                          setFilters([...filters, ...[{ field: 'location', operator: 'eq', value: filterLocation }]])
                        }
                        setFilteredLocationState(true)
                        setAdditionalFilter(true)
                      }
                    } }
                  >
                    <Input type='text' />
                  </FilterDropdown>
                )} /></>
          )}
          {(specialFilter === 'despared') && <Table.Column
            key='warehouse_completed'
            dataIndex="warehouse_completed"
            align="center"
            title={t('order.fields.itemsCompleted')}
            render={(value, record: any) => itemsCompletedCounter(record?.items)}
            sorter
            width= {fixedMobile ? 10 : 1}
          />}
          {(specialFilter === 'despared') && <Table.Column
            key='completed'
            dataIndex="completed"
            align="center"
            title={t('order.fields.completed')}
            width= {fixedMobile ? 10 : 1}
            render={(value, record: Order) => (
              <Space style={{ justifyContent: 'center' }}>
                <CheckboxWithAdvise record={record} />
              </Space>
            )}
            filtered={filteredCompletedState}
            filterDropdown={(props) => (
              <FilterDropdown {...props}
                mapValue={(selectedKeys) => {
                  setFilterCompleted(selectedKeys.toString() === 'true')
                  return selectedKeys.toString() === 'true'
                }}
                clearFilters={() => {
                  setFilters([...filters.filter((x: filter) => x.field !== 'completed')])
                  setFilterCompleted(undefined)
                  setFilteredCompletedState(false)
                  setAdditionalFilter(false)
                }}
                confirm={() => {
                  if (typeof filterCompleted === 'boolean') {
                    if (filters.find((x: filter) => x.field === 'completed')) {
                      const updatedFilters = [...filters]
                      const index = updatedFilters.findIndex((x: filter) => x.field === 'completed')
                      updatedFilters[index].value = filterCompleted

                      setFilters([...updatedFilters])
                    } else {
                      setFilters([...filters, ...[{ field: 'completed', operator: 'eq', value: filterCompleted }]])
                    }
                    setFilteredCompletedState(true)
                    setAdditionalFilter(true)
                  }
                }}
              >
                <Radio.Group>
                  <Radio value={true}>{t('order.fields.completed')}</Radio>
                  <Radio value={false}>{t('order.fields.noCompleted')}</Radio>
                </Radio.Group>
              </FilterDropdown>
            )}
          />}
          {(specialFilter !== 'processed') && CreatedAtColumn}
          {(!specialFilter || specialFilter === 'despared' || specialFilter === 'estimated') && <Table.Column
            key='estimated_delivered_date'
            dataIndex="estimated_delivered_date"
            align="center"
            title={t('order.fields.estimated_delivered_date')}
            render={(value) => (value) ? <DateField format={DEFAULT_DATE_FORMAT} value={value} /> : ''}
            sorter
            width= {fixedMobile ? 10 : 1}
            filtered={filteredEstimatedDateState}
            filterDropdown={() => (
              <DateFilterDropdown
                field='estimated_delivered_date'
                filters={filters}
                setFilters={(newFilter: any, method: string) => {
                  if (newFilter.length > 0 && method === 'merge') {
                    let filtersToAdd = [...filters]

                    if (filters.find((x: filter) => x.field === 'estimated_delivered_date' && x.operator === 'gte')) {
                      const updatedFilters = [...filtersToAdd]
                      const index = updatedFilters.findIndex((x: filter) => x.field === 'estimated_delivered_date' && x.operator === 'gte')
                      updatedFilters[index].value = newFilter[0].value

                      filtersToAdd = [...updatedFilters]
                    } else {
                      filtersToAdd = [...filtersToAdd, ...[newFilter[0]]]
                    }

                    if (filters.find((x: filter) => x.field === 'estimated_delivered_date' && x.operator === 'lte')) {
                      const updatedFilters = [...filtersToAdd]
                      const index = updatedFilters.findIndex((x: filter) => x.field === 'estimated_delivered_date' && x.operator === 'lte')
                      updatedFilters[index].value = newFilter[1].value

                      filtersToAdd = [...updatedFilters]
                    } else {
                      filtersToAdd = [...filtersToAdd, ...[newFilter[1]]]
                    }

                    setFilters([...filtersToAdd])
                    setFilteredEstimatedDateState(true)
                    setAdditionalFilter(true)
                  } else {
                    setFilters([...filters.filter((x: filter) => x.field !== 'estimated_delivered_date')])
                    setFilteredEstimatedDateState(false)
                    setAdditionalFilter(false)
                  }
                }}
              />
            )}
          />}
          {(specialFilter !== 'subscriptions') && (
            <Table.Column
              dataIndex={['marketplace_id', 'name']}
              align="center"
              title={t('order.fields.marketplace')}
              sorter
              width= {fixedMobile ? 7 : 1}
              key="marketplace_id"
              filtered={filteredMarketplaceIdState}
              filterDropdown={(props: FilterDropdownProps) => {
                props.setSelectedKeys = setFilterMarketplaceId
                props.clearFilters = () => {
                  setFilters([...filters.filter((x: filter) => x.field !== 'marketplace_id')])
                  setFilterMarketplaceId(undefined)
                  setFilteredMarketplaceIdState(false)
                  setAdditionalFilter(false)
                }
                props.confirm = () => {
                  if (filterMarketplaceId && filterMarketplaceId.length > 0) {
                    if (filters.find((x: filter) => x.field === 'marketplace_id')) {
                      const updatedFilters = [...filters]
                      const index = updatedFilters.findIndex((x: filter) => x.field === 'marketplace_id')
                      updatedFilters[index].value = filterMarketplaceId

                      setFilters([...updatedFilters])
                    } else {
                      setFilters([...filters, ...[{ field: 'marketplace_id', operator: 'in', value: filterMarketplaceId }]])
                    }
                    setFilteredMarketplaceIdState(true)
                    setAdditionalFilter(true)
                  }
                }
                return <SelectFilterDropdown
                  props={props}
                  entity='marketplaces'
                  optionLabel='name'
                  optionValue='id'
                  filters={[{
                    field: 'deleted',
                    operator: 'eq',
                    value: false
                  }]}
                />
              }}
            />
          )}
          {!warehouseView && <Table.Column
            key='total'
            dataIndex="total"
            align="center"
            title={t('order.fields.billingAmount')}
            sorter
            width= {fixedMobile ? 10 : 1}
            render={(value: number, record: any) => {
              if (specialFilter === 'refunds_provider') {
                const totalAmount = record.refunds.filter((x: any) => !x.deleted && x.type === 'supplier' && x.status_id === 0).map((x: any) => x.amount || 0).reduce((prev: number, next: number) => prev + next, 0)
                return currency(totalAmount)
              } else if (specialFilter === 'refunds') {
                const totalAmount = record.refunds.filter((x: any) => !x.deleted && x.type === 'client' && x.status_id === 0 && x.parent_supplement_id === null && x.amount > 0).map((x: any) => x.amount || 0).reduce((prev: number, next: number) => prev + next, 0)
                return currency(totalAmount)
              } else {
                return currency(value)
              }
            }}
            filtered={filteredTotalState}
            filterDropdown={() => (
              <QuantityFilterDropdown
                field={`${(specialFilter && ['refunds_provider', 'refunds'].includes(specialFilter)) ? '' : 'total'}`}
                filters={filters}
                setFilters={(newFilter: any) => {
                  if (Array.isArray(newFilter)) {
                    setFilters([...newFilter])
                    setFilteredTotalState(true)
                    setAdditionalFilter(true)
                  } else {
                    if (specialFilter && ['refunds_provider', 'refunds'].includes(specialFilter)) {
                      setFilters([...filters.filter((x: filter) => x.field !== '')])
                    } else {
                      setFilters([...filters.filter((x: filter) => x.field !== 'total')])
                    }
                    setFilteredTotalState(false)
                    setAdditionalFilter(false)
                  }
                }}
              />
            )}
          />}
          <Table.Column
            key="status_id"
            dataIndex={['status', 'name']}
            align="center"
            title={t('order.fields.status')}
            width= {fixedMobile ? 10 : 1}
            render={(value, record: Order) => (
              <Tag color={getColorLabel(value, record?.prev_status_id)}>
                {(record?.status_id === ORDER_STATUS_ID_SUBSCRIPTION)
                  ? <p style={{ margin: 0, color: '#0e0460' }}>{capitalizeFirstLetter(value)}</p>
                  : capitalizeFirstLetter(value)
                }
              </Tag>
            )}
            sorter
            filtered={filteredStatusIdState}
            filterDropdown={(props: FilterDropdownProps) => {
              props.setSelectedKeys = setFilterStatusId
              props.clearFilters = () => {
                setFilters([...filters.filter((x: filter) => x.field !== 'status_id' && x.operator === 'in')])
                setFilterStatusId(undefined)
                setFilteredStatusIdState(false)
                setAdditionalFilter(false)
              }
              props.confirm = () => {
                if (filterStatusId && filterStatusId.length > 0) {
                  if (filters.find((x: filter) => x.field === 'status_id' && x.operator === 'in')) {
                    const updatedFilters = [...filters]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'status_id' && x.operator === 'in')
                    updatedFilters[index].value = filterStatusId

                    setFilters([...updatedFilters])
                  } else {
                    setFilters([...filters, ...[{ field: 'status_id', operator: 'in', value: filterStatusId }]])
                  }
                  setFilteredStatusIdState(true)
                  setAdditionalFilter(true)
                }
              }
              return <SelectFilterDropdown
                props={props}
                entity='status'
                optionLabel='name'
                optionValue='id'
                sorters={[{
                  field: 'id',
                  order: 'asc'
                }]}
                excludeFieldsFilter={excludedFields}
              />
            }}
          />
          {(specialFilter == 'subscriptions') && (
            <Table.Column
              key='subscription_status'
              dataIndex={['users_subscriptions', 'status']}
              align="center"
              title={t('order.subscription_status')}
              width= {15}
              render={(value, record: Order) => (
                <Space style={{ justifyContent: 'center' }}>
                  <EditableSubscriptionStatus key={t(`subscription_status.select.${value}`)} record={record} />
                </Space>)}
            />
          )}
          {(specialFilter === 'iva_check') && <Table.Column
            key='url'
            dataIndex='url'
            align="center"
            title={t('order.fields.purchaseUrl')}
            width= {15}
            render={(_value, record: Order) => {
              if (record.marketplace_id.id !== CUSTOM_ORDER_MARKETPLACE_ID) return null

              const url = record.items?.[0]?.url.includes('http') ? record.items?.[0]?.url : null
              if (!url) return null
              else {
                try {
                  const urlData = extractMainDomainFromURL(url)
                  const urlToShow = String(urlData.domainWithoutSuffix || urlData.hostname)
                  return (<p>{urlToShow}</p>)
                } catch (error) {
                  return (<p>{url}</p>)
                }
              }
            }}
          />}
          {(specialFilter === 'iva_check') && <Table.Column
            key="iva_intra"
            dataIndex="iva_intra"
            align="center"
            title={t('order.fields.ivaStatusType')}
            width= {8}
            render={(value) => (value !== null) ? <p>{t(`iva_status.${value}`)}</p> : null}
          />}
          {(specialFilter === 'iva_check') && <Table.Column
            key="intra_iva_affected_items"
            dataIndex="intra_iva_affected_items"
            align="left"
            title="Artículo/s"
            width={15}
            render={(value, record: Order) => (
              <AffectedItemsCell
                key={`${record.id}:${value || ''}`}
                record={record}
                value={value}
                onSave={async (nextValue, target) => {
                  await handleOrderFieldChange('intra_iva_affected_items', nextValue, target, () => undefined)
                  setTableProps({ ...tableProps })
                }}
              />
            )}
          />}
          {(specialFilter === 'iva_check') && <Table.Column
            key="iva_status"
            dataIndex="iva_status"
            align="center"
            title={t('order.fields.ivaStatus')}
            width= {23}
            render={(value, record: Order) => (
              <Space style={{ justifyContent: 'center' }}>
                <EditableSelectField key={t(`iva_status.select.${value}`)} record={record} handleSave={handleIvaStatusChange} field={'iva_status'} options={optionsGetter(record)}/>
              </Space>)}
            filtered={filteredIvaStatusIdState}
            filterDropdown={(props: FilterDropdownProps) => {
              props.clearFilters = () => {
                const updatedFilters = [...filters]
                const index = updatedFilters.findIndex((x: filter) => x.field === 'iva_status' && x.operator === 'in')
                updatedFilters[index].value = [ADVISE_IVA_STATUS, ADVISE_INTRA_STATUS, CONTACTED_SUPPLIER_IVA_STATUS, PROCESS_IVA_STATUS, ADD_SUP_IVA_STATUS, CHANGE_TO_REDUCED]

                setFilters([...updatedFilters])
                setFilterIvaStatusId(undefined)
                setFilteredIvaStatusIdState(false)
                setAdditionalFilter(false)
              }
              props.confirm = () => {
                if (filterIvaStatusId && filterIvaStatusId.length > 0) {
                  if (filters.find((x: filter) => x.field === 'iva_status' && x.operator === 'in')) {
                    const updatedFilters = [...filters]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'iva_status' && x.operator === 'in')
                    updatedFilters[index].value = [...filterIvaStatusId || []]

                    setFilters([...updatedFilters])
                  } else {
                    setFilters([...filters, ...[{ field: 'iva_status', operator: 'in', value: [...filterIvaStatusId || []] }]])
                  }
                  setFilteredIvaStatusIdState(true)
                  setAdditionalFilter(true)
                }
              }
              return <FilterDropdown
                {...props}
                clearFilters={() => {
                  props.clearFilters?.()
                  props.confirm()
                }}
              >
                <Select
                  mode='multiple'
                  onSelect={(value: any) => {
                    const values = [...filterIvaStatusId || [], value]
                    setFilterIvaStatusId(values)
                  }}
                  options={optionsGetter()}
                  style={{ minWidth: 150 }}
                />
              </FilterDropdown>
            }}
          />}
          {(specialFilter === 'sequra') && <Table.Column
            key="sequra_disbursement_ref"
            dataIndex="sequra_disbursement_ref"
            align="center"
            title={t('order.fields.disbursement')}
            width= {fixedMobile ? 12 : 1}
            sorter
            filtered={filteredDisbursementState}
            filterDropdown={(props) => (
              <FilterDropdown {...props}
                mapValue={(selectedKeys) => {
                  setFilterDisbursement(selectedKeys.toString())
                  return selectedKeys.toString()
                }}
                clearFilters={() => {
                  setFilters([...filters.filter((x: filter) => x.field !== 'sequra_disbursement_ref')])
                  setFilterId(undefined)
                  setFilteredDisbursementState(false)
                  setAdditionalFilter(false)
                }}
                confirm={() => {
                  if (filterDisbursement) {
                    if (filters.find((x: filter) => x.field === 'alias')) {
                      const updatedFilters = [...filters]
                      const index = updatedFilters.findIndex((x: filter) => x.field === 'sequra_disbursement_ref')
                      updatedFilters[index].value = filterDisbursement

                      setFilters([...updatedFilters])
                    } else {
                      setFilters([...filters, ...[{ field: 'sequra_disbursement_ref', operator: 'eq', value: filterDisbursement }]])
                    }
                    setFilteredDisbursementState(true)
                    setAdditionalFilter(true)
                  }
                }}
              >
                <Input type='text' />
              </FilterDropdown>
            )}
          />}
          {(specialFilter === 'cancel' || specialFilter === 'return') && <Table.Column
            key="action_dates"
            dataIndex="action_dates"
            align="center"
            title={(specialFilter === 'cancel' || specialFilter === 'return') ? t(`order.fields.${specialFilter}Date`) : t('order.fields.cancellationReturnDate')}
            width= {fixedMobile ? 10 : 2}
            render={({ cancelation_date: cancelationDate, return_date: returnDate }) => {
              if (cancelationDate && !returnDate) {
                return <DateField format={DEFAULT_DATE_FORMAT} value={cancelationDate} />
              }
              if (returnDate && !cancelationDate) {
                return <DateField format={DEFAULT_DATE_FORMAT} value={returnDate} />
              }
              return ''
            }}
            filtered={filteredCancelDateState}
            filterDropdown={() => (
              <>
                {(specialFilter === 'cancel') && <DateFilterDropdown
                  field='cancelation_date'
                  filters={filters}
                  setFilters={(newFilter: any, method: string) => {
                    if (newFilter.length > 0 && method === 'merge') {
                      let filtersToAdd = [...filters]

                      if (filters.find((x: filter) => x.field === 'cancelation_date' && x.operator === 'gte')) {
                        const updatedFilters = [...filtersToAdd]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'cancelation_date' && x.operator === 'gte')
                        updatedFilters[index].value = newFilter[0].value

                        filtersToAdd = [...updatedFilters]
                      } else {
                        filtersToAdd = [...filtersToAdd, ...[newFilter[0]]]
                      }

                      if (filters.find((x: filter) => x.field === 'cancelation_date' && x.operator === 'lte')) {
                        const updatedFilters = [...filtersToAdd]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'cancelation_date' && x.operator === 'lte')
                        updatedFilters[index].value = newFilter[1].value

                        filtersToAdd = [...updatedFilters]
                      } else {
                        filtersToAdd = [...filtersToAdd, ...[newFilter[1]]]
                      }

                      setFilters([...filtersToAdd])
                      setFilteredCancelDateState(true)
                      setAdditionalFilter(true)
                    } else {
                      setFilters([...filters.filter((x: filter) => x.field !== 'cancelation_date')])
                      setFilteredCancelDateState(false)
                      setAdditionalFilter(false)
                    }
                  }}
                  label={t('order.fields.cancelationDate')}
                />}
                {(specialFilter === 'return') && <DateFilterDropdown
                  field='return_date'
                  filters={filters}
                  setFilters={(newFilter: any, method: string) => {
                    if (newFilter.length > 0 && method === 'merge') {
                      let filtersToAdd = [...filters]

                      if (filters.find((x: filter) => x.field === 'return_date' && x.operator === 'gte')) {
                        const updatedFilters = [...filtersToAdd]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'return_date' && x.operator === 'gte')
                        updatedFilters[index].value = newFilter[0].value

                        filtersToAdd = [...updatedFilters]
                      } else {
                        filtersToAdd = [...filtersToAdd, ...[newFilter[0]]]
                      }

                      if (filters.find((x: filter) => x.field === 'return_date' && x.operator === 'lte')) {
                        const updatedFilters = [...filtersToAdd]
                        const index = updatedFilters.findIndex((x: filter) => x.field === 'return_date' && x.operator === 'lte')
                        updatedFilters[index].value = newFilter[1].value

                        filtersToAdd = [...updatedFilters]
                      } else {
                        filtersToAdd = [...filtersToAdd, ...[newFilter[1]]]
                      }

                      setFilters([...filtersToAdd])
                      setFilteredCancelDateState(true)
                      setAdditionalFilter(true)
                    } else {
                      setFilters([...filters.filter((x: filter) => x.field !== 'return_date')])
                      setFilteredCancelDateState(false)
                      setAdditionalFilter(false)
                    }
                  }}
                  label={t('order.fields.returnDate')}
                />}
              </>
            )}
          />}
          {(specialFilter === 'sup_pending_pay' || specialFilter === 'sup_pending_pay_no_volumetric') && <Table.Column
            key="supplements.status_id"
            dataIndex='supplements'
            align="center"
            title={t('order.fields.supplementStatus')}
            width= {fixedMobile ? 7 : 2}
            render={(supplements) => {
              if (supplements.length > 0) {
                const pendingPaymentSupplements = supplements?.filter((supplement: any) => supplement.status.id === ORDER_STATUS_ID_PENDING_PAYMENT && !supplement.volumetric && !supplement.deleted)
                if (pendingPaymentSupplements.length > 0) {
                  return (
                    <Tag color={getColorLabel(PENDING_PAYMENT_STATUS_TEXT)}>
                      {capitalizeFirstLetter(PENDING_PAYMENT_STATUS_TEXT)}
                    </Tag>
                  )
                } else {
                  return (
                    <Tag color={getColorLabel(ADMITTED_STATUS_TEXT)}>
                      {capitalizeFirstLetter(ADMITTED_STATUS_TEXT)}
                    </Tag>
                  )
                }
              }
            }}
          />}
          {(specialFilter === 'sup_pending_pay_volumetric' || specialFilter === 'sup_pending_pay') && <Table.Column
            key="supplements.status_id"
            dataIndex='supplements'
            align="center"
            title={t('order.fields.supplementStatusVolumetric')}
            width= {fixedMobile ? 10 : 2}
            render={(supplements) => {
              if (supplements.length > 0) {
                const pendingPaymentSupplements = supplements?.filter((supplement: any) => supplement.status.id === ORDER_STATUS_ID_PENDING_PAYMENT && supplement.volumetric && !supplement.deleted)
                if (pendingPaymentSupplements.length > 0) {
                  return (
                    <Tag color={getColorLabel(PENDING_PAYMENT_STATUS_TEXT)}>
                      {capitalizeFirstLetter(PENDING_PAYMENT_STATUS_TEXT)}
                    </Tag>
                  )
                } else {
                  return (
                    <Tag color={getColorLabel(ADMITTED_STATUS_TEXT)}>
                      {capitalizeFirstLetter(ADMITTED_STATUS_TEXT)}
                    </Tag>
                  )
                }
              }
            }}
          />}
          {(specialFilter === 'budgeted') && <Table.Column
            key="estimated_costs_status"
            dataIndex="estimated_costs_status"
            align="center"
            title={t('order.fields.estimatedStatus')}
            width= {fixedMobile ? 10 : 2}
            render={(value: any) => {
              if (value) {
                return (<Tag color={getColorLabelEstimatedCost(value || null)}>
                  {MapEstimatedCostsStatusIDToText(value || null)}
                </Tag>)
              } else {
                return null
              }
            }}
            filtered={filteredEstimatedStatusIdState}
            filterDropdown={(props: FilterDropdownProps) => {
              props.clearFilters = () => {
                const updatedFilters = [...filters]
                const index = updatedFilters.findIndex((x: filter) => x.field === 'estimated_costs_status' && x.operator === 'in')
                updatedFilters[index].value = [ADVERTISEMENT_STATUS_ID, SENT_BUDGE_STATUS_ID, ACEPTED_STATUS_ID]

                setFilters([...updatedFilters])
                setFilterEstimatedStatusId(undefined)
                setFilteredEstimatedStatusIdState(false)
                setAdditionalFilter(false)
              }
              props.confirm = () => {
                console.log(filterEstimatedStatusId, filters)
                if (filterEstimatedStatusId && filterEstimatedStatusId.length > 0) {
                  if (filters.find((x: filter) => x.field === 'estimated_costs_status' && x.operator === 'in')) {
                    const updatedFilters = [...filters]
                    const index = updatedFilters.findIndex((x: filter) => x.field === 'estimated_costs_status' && x.operator === 'in')
                    updatedFilters[index].value = [...filterEstimatedStatusId || []]

                    setFilters([...updatedFilters])
                  } else {
                    setFilters([...filters, ...[{ field: 'estimated_costs_status', operator: 'in', value: [...filterEstimatedStatusId || []] }]])
                  }
                  setFilteredEstimatedStatusIdState(true)
                  setAdditionalFilter(true)
                }
              }
              return <FilterDropdown
                {...props}
                clearFilters={() => {
                  props.clearFilters?.()
                  props.confirm()
                }}
              >
                <Select
                  mode='multiple'
                  onSelect={(value: any) => {
                    const values = [...filterEstimatedStatusId || [], value]
                    setFilterEstimatedStatusId(values)
                  }}
                  options={[
                    { label: t('estimated_costs.select.advise'), value: ADVERTISEMENT_STATUS_ID },
                    { label: t('estimated_costs.select.sent'), value: SENT_BUDGE_STATUS_ID },
                    { label: t('estimated_costs.select.accept'), value: ACEPTED_STATUS_ID },
                    { label: t('estimated_costs.select.cancel'), value: CANCELLED_STATUS_ID }
                  ]}
                  style={{ minWidth: 150 }}
                />
              </FilterDropdown>
            }}
          />}
          <Table.Column<Order>
            fixed="right"
            title={t('table.actions')}
            dataIndex="actions"
            key="actions"
            align="center"
            width= {fixedMobile ? 7 : 1}
            // width= {20}
            render={(_, record) => {
              if (record.locked) {
                return (
                  <>
                    <Icons.LockOutlined style={{ color: '#f5222d', fontSize: 20 }} />
                    {record.locked_by === currentUserEmail() && (
                      <ShowButton
                        resourceNameOrRouteName='orders'
                        hideText
                        style={{ color: 'green', fontSize: '15px', marginLeft: 5 }}
                        recordItemId={record.id}
                      />
                    )}
                    <p>{record?.locked_by}</p>
                  </>
                )
              }
              return (
                <ShowButton
                  resourceNameOrRouteName='orders'
                  hideText
                  style={{ color: 'green', fontSize: '15px' }}
                  recordItemId={record.id}
                />
              )
            }}
          />
        </Table>
        <CreateOrder
          drawerProps={createDrawerProps}
          formProps={createFormProps}
          saveButtonProps={createSaveButtonProps}
          closeDrawer={createClose}
        />
      </List>
    </>
  )
}
